/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    errorDialogTitle: {
        label: "Erreur"
    },
    errorDisplayCodeLabel: {
        label: "Code d'erreur"
    },
    errorDisplayDebugLabel: {
        label: "Informations de débogage"
    },
    errorDisplayMessageLabel: {
        label: "Message d'erreur"
    },
    textCopied: {
        label: "Erreur copiée dans le presse-papiers"
    }
};